import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_SHOP } from '@/modules/shop/router';
import { shopService } from '@/services/shop';
import { useMixins } from './mixins';

export function useShopItemAdd() {
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const { model, v$, fetch, iapOptions } = useMixins();

    const actions = {
        create: crudAction.excuteAndNotify({
            validator: v$,
            request: () =>
                shopService.item.create(
                    model.id,
                    model.type,
                    model.name,
                    model.price,
                    model.credit,
                    model.isPublished,
                    model.packageId,
                    model.isBestseller,
                    model.imageFile,
                    model.thumbnailFile
                ),
            onSuccess: () => router.push({ name: ROUTE_NAME_SHOP.INDEX })
        })
    };

    return { model, v$, fetch, actions, iapOptions };
}
